import styles from './ProductCardPricesSecondary.module.scss';
import { Content } from '@wienenergiegithub/ui-next';
import React from 'react';
import classNames from 'classnames';

const ProductCardPricesSecondary = ({
  calculated,
  grundpreise,
  verbrauchspreise,
  isSpotProduct,
}) => {
  const {
    grundpreis,
    grundpreisBasis,
    grundpreisLabel,
    grundpreisMitRabatt,
    grundpreisUnit,
    isGrundPreisRabattiert,
  } = grundpreise;

  const {
    isVerbrauchspreisRabattiert,
    verbrauchspreis,
    verbrauchspreisLabel,
    verbrauchspreisMitRabatt,
    verbrauchspreisSubtext,
    verbrauchspreisUnit,
  } = verbrauchspreise;

  return (
    <div className={styles.container}>
      {/* TODO: check html semantic structure */}
      {!!calculated && !isSpotProduct && (
        <Content
          as="div"
          className={styles.optionsPriceInfo}
          noSpacing
          size="md"
        >
          <span className={styles.priceLabel}>{verbrauchspreisLabel}</span>
          <div className={styles.prices}>
            <span
              className={classNames({
                [styles.priceLabel]: isVerbrauchspreisRabattiert,
              })}
            >
              {isVerbrauchspreisRabattiert
                ? verbrauchspreisMitRabatt
                : verbrauchspreis}{' '}
              {verbrauchspreisUnit}
            </span>
            {isVerbrauchspreisRabattiert && (
              <Content as="span" size="regular">
                {verbrauchspreisSubtext}
              </Content>
            )}
          </div>
        </Content>
      )}
      <Content as="div" className={styles.optionsPriceInfo} noSpacing size="md">
        <span className={styles.priceLabel}>{grundpreisLabel}</span>
        <div className={styles.prices}>
          <span
            className={classNames({
              [styles.priceLabel]: isGrundPreisRabattiert,
            })}
          >
            {isGrundPreisRabattiert ? grundpreisMitRabatt : grundpreis}{' '}
            {grundpreisUnit}
          </span>
          {isGrundPreisRabattiert && (
            <Content as="span" size="regular">
              statt {grundpreisBasis} {grundpreisUnit}
            </Content>
          )}
        </div>
      </Content>
    </div>
  );
};

export default ProductCardPricesSecondary;
